import type { Viewer } from '@alphadesk/web/contract.ts';
import { useEffect } from 'react';
import { capturePage, startUsage, type UsageConfig } from './posthog.ts';

export function useUsage(
  config: UsageConfig | null,
  viewer: Viewer,
  route: { path: string; query: URLSearchParams },
): void {
  useEffect(() => {
    void startUsage(config, viewer);
  }, [config, viewer]);

  const search = route.query.toString();
  useEffect(() => {
    capturePage(route.path, search ? `?${search}` : '');
  }, [route.path, search]);
}
